import { render } from "./ViewContacts.vue?vue&type=template&id=d4b32752&scoped=true&ts=true"
import script from "./ViewContacts.vue?vue&type=script&lang=ts"
export * from "./ViewContacts.vue?vue&type=script&lang=ts"

import "./ViewContacts.vue?vue&type=style&index=0&id=d4b32752&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b32752"]])

export default __exports__